import { useState, useEffect } from 'react';
import io from 'socket.io-client';

const useSocket = (userId: string) => {
  const [socket, setSocket] = useState<any>();

  useEffect(() => {
    if (socket) {
      socket.on('connect', () => console.log('Socket connected to API'));
      socket.on('disconnect', () => console.log('Socket disconnected'));
      socket.on('connect_error', () => console.log('Connect error'));
      socket.io.on('reconnect', (attempt: number) =>
        console.log(`Socket reconnected to API on the ${attempt} attempt`)
      );
      socket.io.on('reconnect_error', () =>
        console.log('Socket reconnected to API failed')
      );
      socket.io.on('reconnect_failed', () =>
        console.log('Socket reconnection failed, unable to connect to API')
      );
    }
    return () => socket?.close();
  }, [socket]);

  useEffect(() => {
    if (userId) {
      const newSocket = io(`${process.env.REACT_APP_API_BASE_URL}`, {
        reconnection: true,
        reconnectionDelay: 5000,
        reconnectionDelayMax: 10000,
        reconnectionAttempts: 5,
        query: {
          u: userId,
        },
      });
      setSocket(newSocket);
    }
  }, [userId]);

  return { socket };
};

export default useSocket;
